import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchClientProfilesResponse } from "./FetchClientProfilesResponse";

const ENDPOINT = "/usermanagement/profiles";

export class FetchClientProfilesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<FetchClientProfilesResponse> {
        var res = await this.executeCommand();
        return new FetchClientProfilesResponse(res);
    }
}
